import styled from "styled-components";
import { buildColor } from "@tvg/design-system";

export const ChangesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${buildColor("white", "900")};
  border: 1px solid ${buildColor("blue", "100")};
  border-radius: 4px;
  height: fit-content;
  justify-content: center;
`;

export const ChangesList = styled.ul`
  width: 100%;
  margin: 0;
  list-style: none;
  padding: 0 12px;
`;

export const ChangesDivisor = styled.li`
  width: 100%;
  padding: 16px 0;
  & :not(:first-child) {
    border-top: 1px solid ${buildColor("blue", "100")};
  }
`;

export const List = styled.ol`
  padding: 0;
  margin: 0;
  list-style: none;
  margin-top: 16px;

  & > li {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 12px;

    &:not(:first-child) {
      margin-top: 8px;
    }
  }
`;

export const Time = styled.time`
  text-transform: uppercase;
  color: ${buildColor("grey", "800")};
  line-height: 1.5;
  padding: 0 2px;
  white-space: nowrap;
`;

export const Dl = styled.dl`
  width: 100%;
  line-height: 1.5;
  margin: 0 0 4px 4px;
`;

export const Dt = styled.dt`
  display: flex;
  flex-wrap: nowrap;
  border-left: 1px solid ${buildColor("blue", "100")};
  padding-left: 4px;
`;

export const Runner = styled.div`
  width: 16px;
  height: 16px;
  margin: 0 4px;
`;

export const RunnerName = styled.h3`
  color: ${buildColor("grey", "900")};
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  margin: 0 4px 0 8px;
`;

export const HeaderWrapper = styled.div`
  border-bottom: 2px solid ${buildColor("blue", "100")};
  border-width: 80%;
  padding: 12px;
  width: 100%;
`;

export const ChangeLblContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid ${buildColor("blue", "100")};
  padding: 0 4px;
  margin-left: 4px;
`;
